<div class="po-row cp-div-external" style="position: relative; width: auto;">
  <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6" style="width: fit-content;">
    <cp-donutchart [value]="inputQuantityOrder.percentageDeliveredUnderValue" [Kind]="Kind"></cp-donutchart>
  </div>
  <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 cp-div-container">
    <div class="po-row"><span class="cp-info-labels">{{ literalsCp?.strPedidos }}</span></div>
    <div class="po-row"><span>{{ inputItem.getFormattedNumber(inputQuantityOrder.orderValue)}}</span></div>
    <br/>
    <div class="po-row"><span class="cp-info-labels">{{ literalsCp?.strEntregue }}</span></div>
    <div class="po-row"><span>{{ inputItem.getFormattedNumber(inputQuantityOrder.orderDeliveredValue)}}</span></div>
  </div>

<po-loading-overlay [hidden]="isHideLoading" p-size="sm">
</po-loading-overlay>

</div>

